module.exports = "https://cdn.realtymogul.com/static/media/graph_history.99fd3310.png";